import React from 'react';
import { User, MoreVertical, Shield, ShieldCheck, Mail } from 'lucide-react';

const MemberCard = ({ member, onAction, isOwner }) => {
    // member object structure expectation:
    // { id, displayName, email, role, avatarUrl, joinedAt, status }

    const getRoleBadge = (role) => {
        switch (role) {
            case 'owner':
                return <span className="bg-amber-100 text-amber-800 text-xs px-2 py-0.5 rounded-full font-bold border border-amber-200">Owner</span>;
            case 'admin':
                return <span className="bg-indigo-100 text-indigo-800 text-xs px-2 py-0.5 rounded-full font-bold border border-indigo-200">Admin</span>;
            default:
                return <span className="bg-gray-100 text-gray-700 text-xs px-2 py-0.5 rounded-full border border-gray-200">Member</span>;
        }
    };

    return (
        <div className="bg-white rounded-xl p-4 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex justify-between items-start mb-4">
                <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden border-2 border-white shadow-sm">
                        {member.avatarUrl ? (
                            <img src={member.avatarUrl} alt={member.displayName} className="w-full h-full object-cover" />
                        ) : (
                            <User className="w-6 h-6 text-gray-400" />
                        )}
                    </div>
                    <div>
                        <h3 className="font-bold text-gray-900">{member.displayName || 'No Name'}</h3>
                        <div className="flex items-center gap-2 mt-0.5">
                            {getRoleBadge(member.role)}
                            <span className="text-xs text-gray-500 flex items-center gap-1">
                                <Mail className="w-3 h-3" /> {member.email}
                            </span>
                        </div>
                    </div>
                </div>

                <button
                    onClick={(e) => { e.stopPropagation(); onAction(member); }}
                    className="p-1 text-gray-400 hover:text-gray-700 rounded-lg hover:bg-gray-50 -mr-2"
                >
                    <MoreVertical className="w-5 h-5" />
                </button>
            </div>

            <div className="grid grid-cols-2 gap-2 mt-2">
                <div className="bg-gray-50 rounded-lg p-2 text-center">
                    <p className="text-[10px] text-gray-500 uppercase tracking-wide">診断回数</p>
                    <p className="text-lg font-bold text-indigo-600">{member.diagnosisCount || 0}</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-2 text-center">
                    <p className="text-[10px] text-gray-500 uppercase tracking-wide">成長スコア</p>
                    <p className="text-lg font-bold text-emerald-600">{member.growthScore || '-'}</p>
                </div>
            </div>

            <div className="mt-3 pt-3 border-t border-gray-50 flex justify-between items-center text-xs text-gray-400">
                <span>Joined: {new Date(member.joinedAt).toLocaleDateString()}</span>
            </div>
        </div>
    );
};

export default MemberCard;
